import React from 'react';
import PageHeader from './PageHeader';
import RichText from '../ui/RichText';
import { isPortableText } from '../../utils/portableTextUtils';
import '../../css/layout/PageChrome.css';

/**
 * Shared page chrome: blue banner (title + subtitle) and optional gray intro body.
 * Use for hub sub-pages and any route with a title + intro paragraph(s).
 */
function normalizeIntroItems(intro) {
  if (intro == null || intro === '') return [];

  if (Array.isArray(intro)) {
    // Single portable-text field (array of blocks) — keep as one RichText value
    if (isPortableText(intro)) return [intro];
    // Multiple intro paragraphs (strings or separate block arrays)
    return intro.filter((item) => item != null && item !== '');
  }

  return [intro];
}

const PageChrome = ({ title, subtitle, intro, sectionTitle, children }) => {
  const introItems = normalizeIntroItems(intro);
  const hasIntroSection = introItems.length > 0 || sectionTitle;

  return (
    <>
      <PageHeader title={title} subtitle={subtitle} />
      <div className="page-content">
        {hasIntroSection && (
          <section className="page-intro">
            {sectionTitle && <h2 className="page-intro-section-title">{sectionTitle}</h2>}
            {introItems.map((item, index) => (
              <RichText key={index} value={item} className="page-intro-text" />
            ))}
          </section>
        )}
        {children}
      </div>
    </>
  );
};

export default PageChrome;
